import {
  GET_AGENCY_SUGGESTED_QUESTIONS_REQUEST,
  GET_AGENCY_SUGGESTED_QUESTIONS_SUCCESS,
  GET_AGENCY_SUGGESTED_QUESTIONS_FAILURE,
} from '../actions/agencyActions';

const initialState = {
  suggestedQuestions: [],
  loading: false,
  error: null,
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    limit: 25,
  },
};

export default function agencyWidget(state = initialState, action) {
  switch (action.type) {
    case GET_AGENCY_SUGGESTED_QUESTIONS_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_AGENCY_SUGGESTED_QUESTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        suggestedQuestions: action.payload.data || action.payload.questions || [],
        pagination: {
          currentPage: action.payload.pagination?.currentPage || 1,
          totalPages: action.payload.pagination?.totalPages || 1,
          totalItems: action.payload.pagination?.totalCount || action.payload.pagination?.totalItems || 0,
          limit: action.payload.pagination?.limit || 25,
        },
      };
    case GET_AGENCY_SUGGESTED_QUESTIONS_FAILURE:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
}


